import { useCallback, useMemo } from 'react';
import styles from './customItems.module.scss';
import { ItemWrapper } from '../wrappers/ItemWrapper';
import { CustomItem } from './CustomItem';
import { ItemsControlCommonProps } from '../wrappers/useItemsField';
import Button from 'components/Button/Button';
import { DeleteIcon } from 'components/icons/icons';

export type CustomItemsProps = ItemsControlCommonProps & {
	renderItem(item: any): any
	uniqueValueKey?: string
	withTopics?: boolean
}

export const CustomItems = (props: CustomItemsProps) => {
	const {
		value = [], onChange,
		errors = [], registerValidators, validateField, onDelete,
		renderItem,
		disabled,
		uniqueValueKey,
		withTopics
	} = props;

	const changeCallback = useCallback(
		(index: number, id: string, newValue: any) => {
			onChange && onChange(index, id, newValue);
		},
		[onChange]
	)

	const itemsContent = useMemo(
		() => {
			return value.map((itemValues, index) => {
				return (
					<div key={uniqueValueKey ? itemValues[uniqueValueKey] : index} className={`${styles.item} ${withTopics ? styles.topics : ''}`}>
						<ItemWrapper
							index={index}
							values={itemValues}
							errorsMap={errors[index]}
							onFieldChange={changeCallback}
							registerValidators={registerValidators}
							validateField={validateField}
							disabled={disabled}
						>
							<CustomItem
								values={itemValues}
								renderItem={renderItem}
								errorsMap={errors[index]}
							/>
						</ItemWrapper>
						{withTopics ?
							<div className={`${styles.delete} ${disabled ? styles.disabled : ''}`}>
								<DeleteIcon
									width={12}
									height={12}
									fill='currentColor'
									onClick={!disabled ? onDelete?.bind(null, index) : undefined}
								/>
							</div>
							:
							<div className={styles.delete}>
								<Button
									text='x'
									color='destructive'
									onClick={onDelete?.bind(null, index)}
									disabled={disabled}
								/>
							</div>
						}
					</div>
				)
			})
		},
		[value, renderItem, errors, disabled, uniqueValueKey, changeCallback, registerValidators, validateField, onDelete, withTopics]
	)

	return (
		<div className={styles.container}>
			{itemsContent}
		</div>
	)
}
